import { createContext, useContext } from "react";

import type { PlatformModel } from "@/api/orval/model";

export type Drawers = "create-platform" | "create-sms-blast";

export type AdminContextValue = {
  mainContentId: string;
  platform?: PlatformModel;
  setPlatform: (platform: PlatformModel | undefined) => void;
  closeDrawer: () => void;
  openDrawer: (drawer: Drawers) => void;
};

export const AdminContext = createContext<AdminContextValue | null>(null);

/**
 * Optional-access variant for components that also render on the login-free Ageless
 * Marketing page, where no admin session — and therefore no AdminContext — exists.
 */
export const useSafeAdminContext = (): AdminContextValue | null => useContext(AdminContext);

export const useAdminContext = () => {
  const context = useContext(AdminContext);

  if (!context) {
    throw new Error("Missing AdminContext provider");
  }

  return context;
};
